import * as ibantools from 'ibantools';

/**
 * An IBAN in the electronic format the console sends and compares: no
 * whitespace or dashes, upper case. Every whitespace character goes first,
 * as the server's normaliser removes them: an IBAN pasted from an email or a
 * web page can carry no-break spaces or tabs between its groups, and
 * ibantools' own formatting strips only ordinary spaces and dashes. Null for
 * an empty or blank value.
 */
export function toElectronicIban(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }
  const compact = value.replace(/\s/g, '');
  if (compact === '') {
    return null;
  }
  return ibantools.electronicFormatIBAN(compact) ?? null;
}
